import { EmptyState, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import systemErrorSVG from './assets/system-error.svg'
import messages from './messages'

export const GlobalSearchErrorState = () => {
  const intl = useProcurifyIntl()

  return (
    <EmptyState
      context='404'
      imgUrl={systemErrorSVG}
      header={intl.formatMessage(messages.header)}
      content={<Text>{intl.formatMessage(messages.content)}</Text>}
    />
  )
}
